import { useStore } from 'lib/store';
import { ImgHTMLAttributes } from 'react';

const Avatar = (props: ImgHTMLAttributes<HTMLImageElement>) => {
    const botIconUrl = useStore((store) => store.config.icons?.botIconUrl);
    return <img src={botIconUrl} height={28} width={27} {...props} />;
};

export default Avatar;
